export default __webpack_public_path__ + "static/media/Copy of The Kruks Photography-243_tn.9a02e061.jpg";